import React from "react";
import { MdLightbulb, MdAssessment } from "react-icons/md";
import AIThinkingLoader from "../common/AIThinkingLoader";

const AIPerformanceInsights = ({ reportData, loading }) => {
  if (loading) {
    return <AIThinkingLoader />;
  }

  if (!reportData) {
    return (
      <div
        className="mt-4 sm:mt-6 rounded-xl border border-primary-cyan/20 overflow-hidden"
        style={{ backgroundColor: "#10182b" }}
      >
        <div className="p-4 sm:p-6 text-center">
          <p className="text-gray-400 text-sm sm:text-base">No AI performance insights available</p>
        </div>
      </div>
    );
  }

  const hasAnalysis =
    reportData.aiPerformanceAnalysis &&
    reportData.aiPerformanceAnalysis.trim() !== "";
  const hasRecommendation =
    reportData.aiPerformanceRecommendation &&
    reportData.aiPerformanceRecommendation.trim() !== "";

  if (!hasAnalysis && !hasRecommendation) {
    return (
      <div
        className="mt-4 sm:mt-6 rounded-xl border border-primary-cyan/20 overflow-hidden"
        style={{ backgroundColor: "#10182b" }}
      >
        <div className="p-4 sm:p-6 text-center">
          <p className="text-gray-400 text-sm sm:text-base">
            No AI performance insights available for this period
          </p>
        </div>
      </div>
    );
  }

  return (
    <div
      className="mt-4 sm:mt-6 rounded-xl border border-primary-cyan/20 overflow-hidden"
      style={{ backgroundColor: "#10182b" }}
    >
      <div className="p-4 sm:p-6 space-y-4 sm:space-y-6">
        <div>
          <div className="flex items-center gap-2 sm:gap-3 mb-3 sm:mb-4">
            <div className="w-8 h-8 sm:w-10 sm:h-10 rounded-xl bg-primary-cyan/20 flex items-center justify-center">
              <MdAssessment className="text-primary-cyan text-xl sm:text-2xl" />
            </div>
            <span className="text-primary-cyan text-xs sm:text-sm font-bold uppercase tracking-wide">
              AI Performance Analysis
            </span>
          </div>
          <div
            className="rounded-xl p-4 sm:p-5"
            style={{ backgroundColor: "#1c2436" }}
          >
            <div className="flex gap-2 sm:gap-3">
              <div className="w-1.5 h-1.5 sm:w-2 sm:h-2 rounded-full bg-primary-cyan mt-2 flex-shrink-0"></div>
              <p className="text-gray-200 text-sm sm:text-base leading-relaxed">
                {hasAnalysis
                  ? reportData.aiPerformanceAnalysis
                  : "No performance analysis available for this period"}
              </p>
            </div>
          </div>
        </div>

        <div>
          <div className="flex items-center gap-2 sm:gap-3 mb-3 sm:mb-4">
            <div className="w-8 h-8 sm:w-10 sm:h-10 rounded-xl bg-primary-cyan/20 flex items-center justify-center">
              <MdLightbulb className="text-primary-cyan text-xl sm:text-2xl" />
            </div>
            <span className="text-primary-cyan text-xs sm:text-sm font-bold uppercase tracking-wide">
              AI Performance Recommendation
            </span>
          </div>
          <div
            className="rounded-xl p-4 sm:p-5"
            style={{ backgroundColor: "#1c2436" }}
          >
            <div className="flex gap-2 sm:gap-3">
              <div className="w-1.5 h-1.5 sm:w-2 sm:h-2 rounded-full bg-primary-cyan mt-2 flex-shrink-0"></div>
              <p className="text-gray-200 text-sm sm:text-base leading-relaxed">
                {hasRecommendation
                  ? reportData.aiPerformanceRecommendation
                  : "No performance recommendation available for this period"}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AIPerformanceInsights;